import { render, staticRenderFns } from "./cardTemplateVip30.vue?vue&type=template&id=5ae47e40&scoped=true&"
import script from "./cardTemplateVip30.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip30.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip30.vue?vue&type=style&index=0&id=5ae47e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae47e40",
  null
  
)

export default component.exports